import {Network} from "../../../network/Network";
import {SedestralMachine} from "../machine/SedestralMachine";
import {Resources} from "../../../resources/Resources";

export class SedestralSsr {

    private static ssrPath: boolean;

    static async init() {
        window["ssr"] = this;
        this.ssrPath = window.location.pathname?.endsWith("sedestral.ssr");
    }

    static hasSsr(): boolean {
        return this.ssrPath;
    }

    static async awaitProcessing() {
        await this.awaitRequests();
        let promises = SedestralMachine.promises.filter(promise => promise.displayRequired);
        if (promises.length > 0) {
            await Promise.all(promises.map(promise => promise.promise));
        }
    }

    static async awaitRequests() {
        let request = await this.awaitRequest();
        if (request) {
            return await this.awaitRequests();
        }
    }

    static async awaitRequest() {
        return SedestralMachine.promise((resolve) => {
            let origOpen = XMLHttpRequest.prototype.open;
            let timeOut = setTimeout(() => {
                resolve(false);
            });

            XMLHttpRequest.prototype.open = function () {
                this.addEventListener('load', function () {
                    resolve(true);
                });
                clearTimeout(timeOut);
                origOpen.apply(this, arguments);
                XMLHttpRequest.prototype.open = origOpen;
            };
        });
    }

    /**
     * SSR
     */

    static async renderPageSsr(path: string) {
        document.body.className = "";
        await Network.router.pages.reload(path);
        await this.awaitProcessing();

        await SedestralMachine.sleep(1);

        if (Network.router.static.components.loader) {
            Network.router.static.components.loader.displayShow();
        }

        document.body.className += "ssrPageReady";
    }

    static getRoutesSsr() {
        const agents = ["alya", "remi", "maya", "nox", "marc", "louise"];
        const customers = ["bet-thermique", "rayssaguel", "areta", "a2com", "abondance", "recifart", "oscar-et-plume",
            "ioelettrodomestici", "powertec", "cartusia", "sportibel", "distock", "bowa", "moom-paris",
            "nova-confort", "kids-literie"];

        return Resources.languages.flatMap(language => {
            return Object.keys(Network.router.pages.pages).flatMap(route => {
                if (route === "/agent") {
                    return agents.map(agent => "/" + language + "/agent/" + agent);
                }
                if (route === "/testimonial") {
                    return customers.map(customer => "/" + language + "/testimonial/" + customer);
                }
                return ["/" + language + route];
            });
        }).join(",");
    }
}